document.addEventListener("product:variant-change", e => {
  const className = e.detail.sectionId.length == 0 ? "product-information" : "stickyaddtocart";
  let compareAtPriceElem = document.querySelector(".stickyaddtocart #price- > span > del > span > span");
  let priceElem = document.querySelector(".stickyaddtocart #price- > span > ins > span > span");
  let afterPayPriceElem = document.querySelector(".product-information--inner #afterpay-price .money");
  const priceFormat = window.theme.settings.money_with_currency_format;
  if(!compareAtPriceElem) {
    compareAtPriceElem = document.querySelector(".stickyaddtocart #price- > span > del > span");
  }
  
  if(!priceElem) {
    priceElem = document.querySelector(".stickyaddtocart #price- > span > ins > span");
  }
  if(!afterPayPriceElem) {
    afterPayPriceElem = document.querySelector(".product-information--inner #afterpay-price");
  }
  
  if (!e.detail.variant) return;
  document.querySelector(`.${className} [value='${e.detail.variant.option1}']`)?.click();
  if (compareAtPriceElem) compareAtPriceElem.innerHTML = formatMoney(e.detail.variant.compare_at_price, priceFormat);
  if (priceElem) priceElem.innerHTML = formatMoney(e.detail.variant.price, priceFormat);
  const stickyAfterpay = document.querySelector(".stickyaddtocart #afterpay-price");
  if (stickyAfterpay) stickyAfterpay.innerHTML = formatMoney(e.detail.variant.price / 4.0, priceFormat);
  if (afterPayPriceElem) afterPayPriceElem.innerHTML = formatMoney(e.detail.variant.price / 4.0, priceFormat);
  // The sticky bar's Save badge was never updated, so after picking Face Only it kept
  // the full set's saving ("SAVE $455" next to a $495 -> $385 price).
  const stickySave = document.querySelector(".stickyaddtocart #price- .badge.onsale .money");
  if (stickySave) {
    const compareAt = e.detail.variant.compare_at_price || 0;
    const saved = compareAt - e.detail.variant.price;
    stickySave.innerHTML = stickySave.textContent.indexOf('%') > -1
      ? Math.round(saved * 100 / compareAt) + '%'
      : formatMoney(saved, priceFormat).replace('.00', '');
    stickySave.closest('.badge').style.display = saved > 0 ? '' : 'none';
  }
  
});

document.querySelectorAll(".afterpay-action").forEach(elem => {
  elem.addEventListener("click", (e) => {
    document
      .querySelector("square-placement")
      ?.shadowRoot
      ?.querySelector("button.afterpay-logo")
      ?.click();
  })
});

function initializeCountdown() {
    const countdownElement = document.getElementById("countdown");
    if (!countdownElement) return; // no announcement-bar countdown on this page
    const targetDate = countdownElement.getAttribute("data-target-date");
    const countdownHours = countdownElement.getAttribute("data-target-hours");

    let targetTime;

    if (targetDate) {
        // Parse the target date if provided
        targetTime = new Date(targetDate).getTime();
    } else if (countdownHours) {
        // Calculate the target time based on the current time and countdown hours
        //const countdownDuration = parseInt(countdownHours) * 60 * 60 * 1000; // Convert hours to milliseconds
        //const now = Date.now();
      
        const today = new Date(); 
        const dynamicDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${(today.getDate()).toString().padStart(2, '0')}T23:59:59`; // Append the fixed time to today's date
        targetTime = new Date(dynamicDate).getTime();
    } else {
        console.error("Either data-target-date or data-target-hours must be provided.");
        return;
    }

    function updateCountdown() {
        const now = Date.now();
        const timeRemaining = targetTime - now;

        if (timeRemaining >= 0) {
            const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
            const hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24).toString().padStart(2, '0');
            const minutes = Math.floor((timeRemaining / (1000 * 60)) % 60).toString().padStart(2, '0');
            const seconds = Math.floor((timeRemaining / 1000) % 60).toString().padStart(2, '0');

            // Update the countdown display
            countdownElement.innerHTML = `
                <strong>${days}</strong> Day <span>:</span>
                <strong>${hours}</strong> Hrs <span>:</span>
                <strong>${minutes}</strong> Mins <span>:</span>
                <strong>${seconds}</strong> Sec
            `;

            // Repeat every second
            setTimeout(updateCountdown, 1000);
        } else {
            if (countdownHours) {
                // Restart the countdown for countdownHours. getMonth() is 0-based —
                // the missing +1 made the restart target a date in the PAST month,
                // and without re-scheduling the tick the display froze at rollover.
        const today = new Date();
        const dynamicDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${(today.getDate()).toString().padStart(2, '0')}T23:59:59`; // Append the fixed time to today's date
        targetTime = new Date(dynamicDate).getTime();
        setTimeout(updateCountdown, 1000);
            } else {
                // Countdown ended for targetDate
                countdownElement.innerHTML = `
                    <strong>00</strong> Day <span>:</span>
                    <strong>00</strong> Hrs <span>:</span>
                    <strong>00</strong> Mins <span>:</span>
                    <strong>00</strong> Sec
                `;
            }
        }
    }

    updateCountdown();
}

document.addEventListener("DOMContentLoaded", initializeCountdown);

document.addEventListener('DOMContentLoaded', function () {
    const squarePlacement = document.querySelector('square-placement');
    const productPriceContainer = document.querySelector('.stickyaddtocart .product-price-container');
    if (squarePlacement && productPriceContainer) {
        const clonedElement = squarePlacement.cloneNode(true);
        productPriceContainer.appendChild(clonedElement);
    }
});


document.addEventListener('DOMContentLoaded', function () {
  const textButtons = document.querySelectorAll('.template-product .text-button');
  const productATC = document.querySelector('.product button#AddToCart');

  if (textButtons.length > 0 && productATC) {
    textButtons.forEach(function (textButton) {
      textButton.addEventListener('click', function (e) {
        e.preventDefault();
        textButton.classList.add('loading');
        // data-vid is stamped at render and never updated on variant change — read
        // the live variant id from the product form's synced hidden input first so
        // CTAs add the variant the customer actually selected.
        const liveIdInput = document.querySelector('.product-information form[data-type="add-to-cart-form"] input[name="id"]');
        const variantId = (liveIdInput && liveIdInput.value) || productATC.getAttribute('data-vid');
        if (variantId) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
            }),
          })
            .then(response => {
              if (!response.ok) {
                throw new Error('Error adding item to cart');
              }
              return response.json();
            })
            .then(data => {
              textButton.classList.remove('loading');
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
             if (document.getElementById('Cart-Drawer')) {
                initiateFlicktyInDrawer();
                 dispatchCustomEvent('cart-drawer:open');
                document.getElementById('Cart-Drawer').open();
                 setTimeout(function(){
                   initiateFlicktyInDrawer();
                 },600);
             }
            })
            .catch(error => {
              textButton.classList.remove('loading');
              console.error('Failed to add item to cart:', error);
            });
        } else {
          textButton.classList.remove('loading');
          console.error('Variant ID not found on AddToCart button.');
        }
      });
    });
  }
});


function setSliderHeightToMax(slider) {
    slider.cells.forEach(cell => cell.element.style.height = '');
        
    let heights = slider.cells.map(cell => cell.element.offsetHeight),
        max = Math.max.apply(Math, heights);
    
    slider.cells.forEach(cell => cell.element.style.height = max + 'px');
}

// Cross-column row alignment for the Custom benefits comparison tables.
// Each product is a COLUMN of stacked cells, so rows only line up while every
// cell in a visual row has the same height. On narrow screens the feature-title
// column (125-152px wide) wraps taller than the 70px min-height the product
// cells keep, and the first column drifts out of alignment — equalize each
// row to its tallest cell instead. Row 0 pairs the title spacer with the
// product image+name header (replaces the hardcoded spacer min-heights).
function alignBenefitRows() {
  document.querySelectorAll('.Custom_benefits').forEach(function (sec) {
    var titles = sec.querySelectorAll('.Custom_benefits_list_title_wrap .list_title');
    var columns = Array.prototype.filter.call(
      sec.querySelectorAll('.Custom_benefits_info_Wrap'),
      function (col) { return col.offsetParent !== null; } // visible variant only
    );
    if (!titles.length || !columns.length) return;

    var rows = [];
    rows.push([titles[0]].concat(columns.map(function (c) {
      return c.querySelector('.Custom_benefits_ct_height');
    })));
    for (var i = 1; i < titles.length; i++) {
      rows.push([titles[i]].concat(columns.map(function (c) {
        return c.querySelectorAll('.col_check')[i - 1] || null;
      })));
    }

    // Reset, then measure, then write — batched so layout only thrashes once.
    rows.forEach(function (row) {
      row.forEach(function (el) { if (el) el.style.height = ''; });
    });
    var heights = rows.map(function (row) {
      return Math.max.apply(Math, row.map(function (el) {
        return el ? el.offsetHeight : 0;
      }));
    });
    rows.forEach(function (row, r) {
      row.forEach(function (el) { if (el) el.style.height = heights[r] + 'px'; });
    });
  });
}

// Re-run whenever measurements can change: fonts swap line heights, late
// image loads change the header row, resize crosses the desk/mobile variant
// breakpoint (offsetParent flips which variant is visible).
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(function () { try { alignBenefitRows(); } catch (e) {} });
}
window.addEventListener('load', function () { try { alignBenefitRows(); } catch (e) {} });
var __benefitAlignTimer;
var __benefitAlignWidth = window.innerWidth;
window.addEventListener('resize', function () {
  // Row heights only change with width; skip height-only resizes (phone toolbar).
  if (window.innerWidth === __benefitAlignWidth) return;
  __benefitAlignWidth = window.innerWidth;
  clearTimeout(__benefitAlignTimer);
  __benefitAlignTimer = setTimeout(alignBenefitRows, 150);
}, { passive: true });

function blogSlider(){
  let elem = document.querySelector('.blog-posts .blog-slider');
  if (elem) {
    let flkty = new Flickity(elem, {
      cellAlign: 'left',
      prevNextButtons: false,
      wrapAround: true,
      pageDots: false,
      draggable: true,
      contain: true
    });

    let snext = document.querySelector('.blog-slider-nav .next-article');
    let sprev = document.querySelector('.blog-slider-nav .prev-article');

    function updateNavButtons() {
      if (flkty.selectedIndex === 0) {
        sprev?.classList.add('disabled'); // Add 'disabled' class to prev button if first slide
      } else {
        sprev?.classList.remove('disabled'); // Remove 'disabled' class if not first slide
      }

      if (flkty.selectedIndex === flkty.slides.length - 1) {
        snext?.classList.add('disabled'); // Add 'disabled' class to next button if last slide
      } else {
        snext?.classList.remove('disabled'); // Remove 'disabled' class if not last slide
      }
    }
    
    snext.addEventListener('click', function() {
      flkty.next();
      updateNavButtons();
    });
    
    sprev.addEventListener('click', function() {
      flkty.previous();
      updateNavButtons();
    });
    updateNavButtons();
    setTimeout(function(){
      flkty.resize(); 
      updateNavButtons();
    },500);
  }
}

function initializeAFBFlickity() {
  // One page can hold several afb-slider sections (reviews-slider and
  // after-before-section share this markup) — bind EACH slider to the arrows
  // inside its own section, or a second instance renders as a dead row wired
  // to the first one's nav.
  document.querySelectorAll('.afb-slider').forEach(function (elem) {
    if (elem.dataset.luyorsBound) return; // editor section:load re-runs this — bind once
    elem.dataset.luyorsBound = '1';
    let flkty = new Flickity(elem, {
      cellAlign: 'left',
      prevNextButtons: false,
      wrapAround: true,
      pageDots: false,
      draggable: true,
      contain: true
    });

    let root = elem.closest('.afterbefore-section') || document;
    let snext = root.querySelector('.csnav.csnav-next');
    let sprev = root.querySelector('.csnav.csnav-prev');

    // Function to check if the slider is at the first or last slide
    function updateNavButtons() {
      if (flkty.selectedIndex === 0) {
        sprev?.classList.add('disabled'); // Add 'disabled' class to prev button if first slide
      } else {
        sprev?.classList.remove('disabled'); // Remove 'disabled' class if not first slide
      }

      if (flkty.selectedIndex === flkty.slides.length - 1) {
        snext?.classList.add('disabled'); // Add 'disabled' class to next button if last slide
      } else {
        snext?.classList.remove('disabled'); // Remove 'disabled' class if not last slide
      }
    }

    // Next button listener
    snext?.addEventListener('click', function () {
      flkty.next();
      updateNavButtons(); // Update button states after navigation
    });

    // Previous button listener
    sprev?.addEventListener('click', function () {
      flkty.previous();
      updateNavButtons(); // Update button states after navigation
    });

    // Initial button state update
    updateNavButtons();

    // Trigger resize after ensuring content layout
    window.addEventListener('load', function () {
      flkty.resize();
      updateNavButtons(); // Ensure button states are correct after resize
    });
  });
}



function initializeThumbSlider() {
  var thumbs = document.querySelector('#Product-Thumbnails');

  if (thumbs) {
    var thumbCount = thumbs.childElementCount;

    // Clone all thumbnails if fewer than 6
    if (thumbCount < 6) {
      for (var i = 0; i < 6; i++) {
        var clone = thumbs.children[i % thumbCount].cloneNode(true);
        clone.classList.add('cloned-thumb'); // Add 'cloned-thumb' class
        thumbs.appendChild(clone);
      }
    }

    var thumbSlider = new Flickity(thumbs, {
      cellAlign: 'left',
      asNavFor: document.querySelector('#Product-Slider'),
      pageDots: false,
      wrapAround: false,
      contain: true,
      prevNextButtons: true
    });

    setTimeout(function () {
      thumbSlider.resize();

      let mainSlider = document.querySelector('#Product-Slider').flickityInstance;

      mainSlider.on('change', function (index) {
        thumbSlider.select(index);
      });

      thumbSlider.on('change', function (index) {
        mainSlider.select(index);
      });

    }, 500);
  }
}




function initializeVideoSlider() {
  // var videos = document.querySelector('.video-images-slides');

  // if (videos) {
  //   // var videoSlider = new Flickity(videos, {
  //   //   cellAlign: 'center',
  //   //   pageDots: false,
  //   //   initialIndex: 2,
  //   //   prevNextButtons: false,
  //   //   contain: true,
  //   //   on: {
  //   //     ready: function() {
  //   //       setSliderHeightToMax(this); // Set the height of the slider when it's ready
  //   //     }
  //   //   }
  //   // });

  //   // Resize the slider height when the window is resized
  //   window.addEventListener('resize', function() {
  //     setSliderHeightToMax(videoSlider);
  //   });

  //   window.addEventListener("load", () => {
  //     setTimeout(function() {
  //       videoSlider.resize(); 
  //     }, 500);
  //   });
    
  // }

  function initVideoSlider() {
  const $slider = $('.video-images-slides');
  const screenWidth = window.innerWidth;

  if (screenWidth <= 767) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: false,
        centerMode: true,
        variableWidth: false,
        adaptiveHeight: false,
        infinite: false,
        initialSlide: 1,
      });
      // Unmuted testimonials: swiping to another slide must not leave the
      // previous video talking off-screen. Namespaced + .off first so the
      // 767px-crossing re-inits and editor section:load reloads never stack.
      $slider.off('beforeChange.luyorsPause').on('beforeChange.luyorsPause', function () {
        document.querySelectorAll('.video-image-slide video').forEach(function (v) { v.pause(); });
      });
    }
  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

// Run on page load and on resize
$(document).ready(function () {
  initVideoSlider();
  // Bind-once: shopify:section:load re-runs initializeVideoSlider() in the
  // theme editor — without this flag each run stacked another resize handler.
  if (!window.__luyorsVideoResizeBound) {
    window.__luyorsVideoResizeBound = true;
    // Debounced 150ms — same pattern as the moveResponsiveElements resize listener.
    var __videoSliderResizeTimer;
    $(window).on('resize', function () {
      clearTimeout(__videoSliderResizeTimer);
      __videoSliderResizeTimer = setTimeout(initVideoSlider, 150);
    });
  }
});

  

  // Handle play/pause functionality when clicking the play/pause button
  var playPauseButtons = document.querySelectorAll('.video-image-slide .playpausebtn');
  playPauseButtons.forEach(function(button) {
    // Bind-once: shopify:section:load re-runs this in the theme editor —
    // duplicate listeners made each click play+pause in the same tick.
    if (button.dataset.luyorsBound) return;
    button.dataset.luyorsBound = '1';
    button.addEventListener('click', function() {
      var parentSlide = this.closest('.video-image-slide');
      var video = parentSlide.querySelector('video'); // Get the video inside the parent slide

      if (parentSlide.classList.contains('is-playing')) {
        // If the parent has 'is-playing', pause the video and remove the class
        video.pause();
        parentSlide.classList.remove('is-playing');
        this.setAttribute('aria-pressed', 'false');
      } else {
        // If the parent doesn't have 'is-playing', pause all videos in the slider first
        var allVideos = document.querySelectorAll('.video-image-slide video');
        allVideos.forEach(function(v) {
          v.pause(); // Pause all videos
        });

        video.play(); // Play the current video's sibling video
        parentSlide.classList.add('is-playing'); // Add the 'is-playing' class to the parent
        this.setAttribute('aria-pressed', 'true');
      }
    });
  });

  // Detect when a video is paused and remove 'is-playing' class from its parent
  var allVideos = document.querySelectorAll('.video-image-slide video');
  // Unmuted testimonials: pause any video that scrolls mostly (>80%) out of
  // view so the audio doesn't keep narrating the rest of the page.
  var videoViewObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio < 0.2 && !entry.target.paused) entry.target.pause();
    });
  }, { threshold: 0.2 }) : null;
  allVideos.forEach(function(video) {
    if (video.dataset.luyorsBound) return; // editor section:load re-runs this — bind once
    video.dataset.luyorsBound = '1';
    video.addEventListener('pause', function() {
      var parentSlide = video.closest('.video-image-slide');
      if (parentSlide && parentSlide.classList.contains('is-playing')) {
        parentSlide.classList.remove('is-playing'); // Remove the 'is-playing' class from the parent
      }
      // Keep the button's a11y state honest no matter what triggered the pause.
      var btn = parentSlide && parentSlide.querySelector('.playpausebtn');
      if (btn) btn.setAttribute('aria-pressed', 'false');
    });
    if (videoViewObserver) videoViewObserver.observe(video);
  });
}




document.addEventListener("DOMContentLoaded", function(){
  try { initializeAFBFlickity(); } catch(e){}
  try { initializeThumbSlider(); } catch(e){}
  try { initializeVideoSlider(); } catch(e){}
  try { blogSlider(); } catch(e){}
  try { alignBenefitRows(); } catch(e){}
});




function openTab(tabId) {
  // Remove active class from all tab buttons
  const buttons = document.querySelectorAll('.cstm-tabs-btn');
  buttons.forEach((btn) => btn.classList.remove('active'));

  // Remove active class from all tab contents
  const contents = document.querySelectorAll('.cstm-tabs-content');
  contents.forEach((content) => content.classList.remove('active'));

  // Add active class to the selected tab button
  document.querySelector(`.cstm-tabs-btn[onclick="openTab('${tabId}')"]`).classList.add('active');

  // Add active class to the selected tab content
  document.getElementById(tabId).classList.add('active');
}



// Select all elements with .logo-list__inner
// const logoListInners = document.querySelectorAll('.logo-list .logo-list__inner');

// // Map to store Flickity instances
// const flickityInstances = new Map();

// // Function to initialize or destroy Flickity for all elements
// function toggleFlickity() {
//   const screenWidth = window.innerWidth;

//   logoListInners.forEach((logoListInner, index) => {
//     if (screenWidth <= 767) {
//       // Initialize Flickity if not already initialized
//       if (!flickityInstances.has(index)) {
//         const flickityInstance = new Flickity(logoListInner, {
//           cellAlign: 'center',
//           wrapAround: true,
//           pageDots: false,
//           prevNextButtons: false,
//           autoPlay: 2000
//         });
//         flickityInstances.set(index, flickityInstance);
//       }
//     } else {
//       // Destroy Flickity if initialized
//       if (flickityInstances.has(index)) {
//         const flickityInstance = flickityInstances.get(index);
//         flickityInstance.destroy();
//         flickityInstances.delete(index); // Remove the instance
//       }
//     }
//   });
// }

// // Add event listener to handle resize
// window.addEventListener('resize', toggleFlickity);

// // Run on initial load
// toggleFlickity();
// Last width the logo slider was laid out for. Height-only resizes (a phone's
// toolbar collapsing while scrolling, the testimonials carousel's synthetic
// resize on load) used to tear down and rebuild the slider every time.
var __logoSliderWidth = null;
function toggleSlickSlider() {
  const $slider = $('.logo-list__inner');
  const screenWidth = window.innerWidth;
  if (screenWidth === __logoSliderWidth) return;
  __logoSliderWidth = screenWidth;
  // One rule for load and resize: 1 logo up to 767px, 2 on tablets. Load used to
  // start tablets at 1 and the first resize switched them to 2.
  const slidesToShow = screenWidth <= 767 ? 1 : 2;

  if (screenWidth <= 1024) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        touchThreshold: 100
      });
    } else if ($slider.slick('slickGetOption', 'slidesToShow') !== slidesToShow) {
      // Rebuild only when the count actually changes (refresh=true unloads and re-inits).
      $slider.slick('slickSetOption', 'slidesToShow', slidesToShow, true);
    }
  } else if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
}

$(document).ready(function () {
  if (typeof $.fn.slick !== 'function') return;
  toggleSlickSlider();

  // Debounced 150ms — same pattern as the moveResponsiveElements resize listener.
  var __logoSliderResizeTimer;
  $(window).on('resize', function () {
    clearTimeout(__logoSliderResizeTimer);
    __logoSliderResizeTimer = setTimeout(toggleSlickSlider, 150);
  });
});



document.querySelectorAll('.c-popup-wrapper').forEach((popup) => {

  const triggerSelector = popup.getAttribute('data-trigger');
  const triggerElement = document.querySelector(triggerSelector);

  if (triggerElement) {
    triggerElement.addEventListener('click', (event) => {
      event.preventDefault();
      popup.classList.add('active');
      document.body.classList.add('popout-open');
    });
  } else {
    console.warn(`Trigger element not found for selector: ${triggerSelector}`);
  }
  
});


document.querySelectorAll('.c-pop-close').forEach((closeButton) => {
  closeButton.addEventListener('click', () => {
    document.querySelectorAll('.c-popup-wrapper').forEach((popup) => {
      popup.classList.remove('active');
    });
    document.body.classList.remove('popout-open');
  });
});


function responsiveMove(elementSelector, targetSmallScreenSelector, targetLargeScreenSelector, breakpoint = 767, position = 'before') {
  const element = document.querySelector(elementSelector);
  const targetSmallScreen = document.querySelector(targetSmallScreenSelector);
  const targetLargeScreen = document.querySelector(targetLargeScreenSelector);

  if (!element || !targetSmallScreen || !targetLargeScreen) {
    console.warn('Element or targets not found for responsiveMove:', { elementSelector, targetSmallScreenSelector, targetLargeScreenSelector });
    return;
  }

  function moveElement() {
    const screenWidth = window.innerWidth;
    const target = (screenWidth <= breakpoint) ? targetSmallScreen : targetLargeScreen;

    // Insertion reference node (may be a whitespace text node) used by insertBefore.
    const referenceNode = (position === 'before') ? target : target.nextSibling;

    // The ELEMENT we want to end up immediately before, ignoring whitespace/text nodes.
    const desiredNextEl = (position === 'before') ? target : target.nextElementSibling;

    // CLS guard: skip the DOM write when the element is ALREADY immediately before the
    // desired element (ignoring whitespace text nodes). Comparing raw .nextSibling never
    // matches (server HTML puts a whitespace text node between elements), which left the
    // guard inert and the post-paint reflow (CLS) in place.
    if (element.nextElementSibling === desiredNextEl) {
      return;
    }

    target.parentNode.insertBefore(element, referenceNode);
  }

  // Run on initial load
  moveElement();
}


function moveResponsiveElements(){
  responsiveMove('.pfp-features', '.pdp-badges', '.luy-gifts, variant-selects', 767, 'before'); // .luy-gifts first: on the Equinox PDP bullets stay ABOVE the gifts strip (guard then no-ops); other PDPs fall through to variant-selects as before
  responsiveMove('.customer-review .cr-c', '.customer-review .cr-image img', '.customer-review .cr-content-review', 767, 'after');
  responsiveMove('.therapy-works .cr-c', '.therapy-works .customer-review .cr-image img', '.therapy-works .cr-content-review', 767, 'after');
  responsiveMove('.afterbefore-wraper .custom-nav', '.afb-right .afb-slider', '.afterbefore-wraper .afb-content-text', 767, 'after');
  responsiveMove('.cstmtans-left > .button', '.cstm-tabs-container .cstm-tabs-contents', '.cstmtans-left .cstmtab-content', 767, 'after');
  responsiveMove('.review-homepage.text-with-icons .text-with-icons__block-content h6', '.section-text-with-icons .review-homepage.text-with-icons .text-with-icons__icon img', '.review-homepage.text-with-icons .text-with-icons__block-content p', 767, 'before');
  responsiveMove('.blog-slider-nav', '.blog-posts.blog-section > .text-center > .button', '.blog-header-wrap.has-slider .section-header', 767, 'after');
  responsiveMove('.faq-section .bottom-btn-rating', '.faq-sec-wrapper', '.faq-sec-wrapper .customer-review', 767, 'after');
}

moveResponsiveElements();

// Single debounced, passive resize listener for all responsive moves.
// Replaces the previous per-call window.addEventListener('resize', ...) inside
// responsiveMove(), which leaked ~8 listeners on every moveResponsiveElements()
// run (and re-added them on every shopify:section:load).
var __responsiveMoveResizeTimer;
var __responsiveMoveWidth = window.innerWidth;
window.addEventListener('resize', function () {
  // The moves key off a 767px width breakpoint; height-only resizes can't change them.
  if (window.innerWidth === __responsiveMoveWidth) return;
  __responsiveMoveWidth = window.innerWidth;
  clearTimeout(__responsiveMoveResizeTimer);
  __responsiveMoveResizeTimer = setTimeout(moveResponsiveElements, 150);
}, { passive: true });


document.addEventListener('shopify:section:load', function(event) {
  initializeAFBFlickity();
  initializeThumbSlider();
  initializeVideoSlider();
  moveResponsiveElements();
  initializeCountdown();
  blogSlider();
  try { alignBenefitRows(); } catch(e){}
});


let lastScrollPosition = 0; 

// GLOB-06: element lookups hoisted out of the scroll handler (script runs with
// defer, so the DOM is parsed); null-guard below keeps behavior identical.
let observedElement = document.querySelector('button#AddToCart.sticky-add-tocart-main');
let headerElement = document.querySelector('theme-header#header');
let stickyAddToCart = document.querySelector('.stickyaddtocart');
let stickyScrollTicking = false;

window.addEventListener('scroll', function() {
  if (stickyScrollTicking) return;
  stickyScrollTicking = true;
  requestAnimationFrame(() => {
    let scrolledPosition = window.scrollY;

    if (observedElement && headerElement && stickyAddToCart) {
      let observedElementTop = observedElement.getBoundingClientRect().top + window.scrollY;
      let headerHeight = headerElement.offsetHeight;

      // Check if scrolling down and above the threshold
      if (scrolledPosition > lastScrollPosition && scrolledPosition > (observedElementTop - headerHeight)) {
        stickyAddToCart.classList.add('active');
      } 
      
      // Check if scrolling up
      else if (scrolledPosition < lastScrollPosition) {
        stickyAddToCart.classList.remove('active');
      }

      // Update the last scroll position
      lastScrollPosition = scrolledPosition;
    }
    stickyScrollTicking = false;
  });
});


// Flickity instances made for the drawer's trust strip. Each drawer re-render swaps in
// fresh markup, and the old instance kept its 3s autoplay, its rAF animation and its
// window resize listener running on the detached element (6 instances after 5 cart
// updates, ~3x the animation frames). Destroy detached ones before making a new one.
var __drawerFlickities = [];
function initiateFlicktyInDrawer() {
    if (typeof Flickity === 'undefined') return;
    __drawerFlickities = __drawerFlickities.filter(function (f) {
        if (document.contains(f.element)) return true;
        try { f.destroy(); } catch (e) {}
        return false;
    });
   
    // Scope to THIS slider's container — the old page-wide `.icon-block`
    // selector would miscount if that class were ever reused elsewhere on the
    // page. (Flickity v2 uses shiftWrap/transforms, not DOM clones, so no clone
    // cells inflate this count — no clone-exclusion needed.)
    const blocks = document.querySelectorAll('.icons-container .icon-block').length;

    if (blocks > 1) {
        document.querySelectorAll('.icons-container .content-wrapper').forEach(wrapper => {
            // Guard: this fn runs from ~9 call sites (open, every cart change,
            // auto-bundle, a 600ms retry). Re-initializing an already-Flickity
            // wrapper double-wraps its cells and stacks another autoplay timer —
            // the slider stutters / shows duplicate icons. A fresh re-render
            // replaces the wrapper (no flickity-enabled class), so real re-inits
            // still work.
            if (wrapper.classList.contains('flickity-enabled')) return;
            __drawerFlickities.push(new Flickity(wrapper, {
                prevNextButtons: false,
                pageDots: false,
                imagesLoaded: true,
                autoPlay: 3000,
                wrapAround: true
            }));
        });
    } else {
        const centerWrapper = document.querySelector('.content-wrapper');
        if (centerWrapper) centerWrapper.classList.add('center');
    }
}
 
(function() {
  function initBlogLightbox() {
    var lightbox = document.getElementById('blogLightbox');
    var lightboxImg = document.getElementById('blogLightboxImg');
    var closeBtn = document.getElementById('blogLightboxClose');
    if (!lightbox || !lightboxImg) return;

    document.addEventListener('click', function(e) {
      var img = e.target.closest('.blog-graphic-zoomable');
      if (img) {
        lightboxImg.src = img.src;
        lightboxImg.alt = img.alt;
        lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });

    function closeLightbox() {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }

    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox || e.target === closeBtn) closeLightbox();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogLightbox);
  } else {
    initBlogLightbox();
  }
})();    

